<template>
  <div class="main-wrapper new-page-view">
    <div class="loading-wrapper">
      <div class="row h-100 align-items-center">
        <div class="col text-center">
        </div>
      </div>
    </div>
    <div v-if="loading"
         class="loading-area"
    >
    </div>
    <div v-else>
      <router-view name="top" />
      <router-view
        v-if="!siriusCompanyContract.link"
        name="sidebar"
        class="sidebar"
      />
      <router-view v-if="!siriusCompanyContract.link"
                   name="tab"
                   class="tab"
      />
      <!-- <router-view name="sidebar"
                   class="sidebar"
      />
      <router-view name="tab"
                   class="tab"
      /> -->
      <transition name="slide-fade"
                  mode="out-in"
      >
        <router-view :key="$route.path"
                     name="content"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import checkAuthenticate from '@/static/check.authenticate';
import AccountService from '@/services/account';

export default {
  name: 'Layout',

  data() {
    return {
      loading: true,
      status: false,
      // deferredPrompt: null,
      toTop: false,
    };
  },

  async created () {
    const self = this;

    if (
      (AccountService.checkAuth() || this.$route.meta.requiresAuth)
      && !this.currentUser.username
    ) {
      // console.log(JSON.parse(AccountService.getUserInfo()));
      this.setCurrentUser(JSON.parse(AccountService.getUserInfo()));
      // this.setUserGuidingSegment();
      self.loading = false;
      self.status = false;
      self.checkAuth();
      if (this.siriusCompanyContract.link) {
        this.$router.push({ name: 'HemenBulCompanyContractView' });
      }
    } else self.loading = false;

    window.addEventListener('scroll', this.scrollFunction);
  },

  methods: {
    ...mapMutations([
      'setCompanyClosingDate',
      'setCurrentUser',
      'setCompanyContract',
      'setExpressSearch',
    ]),

    checkAuth() {
      const auth = this.$route.meta.authenticate;
      if (auth) {
        const list = this.currentUser.nonAuthorizedPermissions || [];
        if (list.some((value) => value === auth)) {
          const viewName = checkAuthenticate(list);
          this.$router.push({ name: viewName });
        }
      }
    },

    scrollFunction() {
      if (this.$route.name === 'LoginView') return false;
      this.toTop = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
    },
    // When the user clicks on the button, scroll to the top of the document
    topFunction() {
      $('html, body').animate({ scrollTop: 0 }, 600);
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-area {
  height: 100vh;
}
#toTop {
  width: 40px;
  height: 40px;
  padding: 10px;
  display: block;
  position: fixed;
  bottom: 72px;
  right: 30px;
  text-align: center;
  z-index: 99;
  border: none;
  outline: none;
  background-color: rgba(131, 22, 181, 0.3);
  color: white;
  cursor: pointer;
  border-radius: 50%;
  font-size: 18px;
}

#toTop:hover {
  background-color: rgba(131, 22, 181, 1); /* Set a background color */
}
</style>
